import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileInvoice, faWeightHanging } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';

const DeliveryOverview = ({ data }) => {
    const { t } = useTranslation();
    if (!data) return null;

    const strings = t('deliveryAnalytics.overview', { returnObjects: true });

    const cards = [
        {
            label: strings.totalChallans,
            value: data.total_challans ?? 0,
            icon: faFileInvoice,
            color: '#0891b2', bg: '#ecfeff', border: '#a5f3fc',
            sub: strings.subs.inSelectedPeriod,
        },
        {
            label: strings.totalWeight,
            value: `${parseFloat(data.total_weight_tons || 0).toFixed(2)} ${strings.tonSuffix}`,
            icon: faWeightHanging,
            color: '#7c3aed', bg: '#f5f3ff', border: '#ddd6fe',
            sub: strings.subs.dispatchedWeight,
        },
    ];

    return (
        <div style={{ marginBottom: 28 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 }}>
                <div style={{ width: 3, height: 18, borderRadius: 2, backgroundColor: '#111827' }} />
                <span style={{ fontSize: 16, fontWeight: 700, color: '#111827' }}>{strings.challanOverview}</span>
                {data.from_date && data.to_date && (
                    <span style={{ fontSize: 12, color: '#9ca3af', marginLeft: 6 }}>
                        {data.from_date} → {data.to_date}
                    </span>
                )}
            </div>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
                {cards.map(card => (
                    <div
                        key={card.label}
                        style={{
                            flex: '1 1 180px', minWidth: 180, maxWidth: 300,
                            backgroundColor: '#ffffff',
                            border: `1px solid ${card.border}`,
                            borderRadius: 12,
                            padding: '16px 18px',
                            display: 'flex', flexDirection: 'column', gap: 8,
                            transition: 'box-shadow 0.15s', cursor: 'default',
                        }}
                        onMouseEnter={e => e.currentTarget.style.boxShadow = `0 4px 16px ${card.border}99`}
                        onMouseLeave={e => e.currentTarget.style.boxShadow = 'none'}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <span style={{ fontSize: 11.5, fontWeight: 600, color: '#111827', textTransform: 'uppercase', letterSpacing: '0.4px' }}>
                                {card.label}
                            </span>
                            <div style={{
                                width: 32, height: 32, borderRadius: 8,
                                backgroundColor: card.bg,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                color: card.color, fontSize: 13, flexShrink: 0, marginLeft: 8
                            }}>
                                <FontAwesomeIcon icon={card.icon} />
                            </div>
                        </div>
                        <div style={{ fontSize: 26, fontWeight: 800, color: '#111827', lineHeight: 1 }}>{card.value}</div>
                        <div style={{ fontSize: 11, color: '#111827' }}>{card.sub}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default DeliveryOverview;
